(function ($, root, undefined) {

    'use strict';

    function toggleMagazinePopup() {

        let popup = $('#popup-magazine');
        popup.height($(document).height());
        popup.toggle();
        $("html, body").animate({ scrollTop: 0 }, "slow");

        return false;
    }


    /*
     *      DOCUMENT READY
     */

    jQuery(document).ready(function () {

        $(".toggle-magazine-popup").on("click", toggleMagazinePopup);

    })

})(jQuery, this);